module.exports = __webpack_public_path__ + "img/banner.06af815a.png";